import axios, { AxiosInstance } from "axios";
import {
  getAuth,
  signInWithEmailAndPassword,
  confirmPasswordReset,
  signOut,
  FacebookAuthProvider,
  GoogleAuthProvider,
  signInWithPopup,
  applyActionCode,
} from "firebase/auth";

export class AuthFirebaseRestClient {
  private url: string;
  public client: AxiosInstance;

  constructor(url: string) {
    this.url = url;
    this.createClient();
  }

  public createClient() {
    const client = axios.create({
      baseURL: this.url,
    });

    client.defaults.headers["Content-Type"] = "application/json; charset=utf-8";
    client.defaults.headers.Accept = "application/json; charset=utf-8";

    this.client = client;
  }

  public async login(username: string, password: string): Promise<any> {
    const auth = getAuth();
    return signInWithEmailAndPassword(auth, username, password);
  }

  public async restore(code: string, newPassword: string): Promise<any> {
    const auth = getAuth();
    return confirmPasswordReset(auth, code, newPassword);
  }

  public async verify(oobCode: string) {
    const auth = getAuth();
    return await applyActionCode(auth, oobCode);
  }

  public async loginWithGoogle(homemarket: string) {
    const auth = getAuth();
    const providerGoogle = new GoogleAuthProvider();
    const responseLogin = await signInWithPopup(auth, providerGoogle);

    const cloneResponseLogin: any = JSON.parse(JSON.stringify(responseLogin));

    const credential = GoogleAuthProvider.credentialFromResult(responseLogin);
    let response: any = null;

    if (cloneResponseLogin._tokenResponse.isNewUser) {
      const user = {
        ...responseLogin.user,
        providerId: responseLogin.providerId,
        accessToken: credential?.accessToken,
        name: cloneResponseLogin._tokenResponse.firstName,
        surname: cloneResponseLogin._tokenResponse.lastName,
        phoneNumber: cloneResponseLogin._tokenResponse.phoneNumber,
        homemarket,
        channel: "WEB",
        origin: "google.com",
      };
      response = await this.client.post("/v2/register-external-provider", user);
    }

    if (response) {
      response.data.content.accessToken = credential?.accessToken;
      response.data.content.responseFirebase = {
        ...responseLogin.user,
        firstName: cloneResponseLogin._tokenResponse.firstName,
        lastName: cloneResponseLogin._tokenResponse.lastName,
      };
    } else {
      response = {
        data: {
          content: {
            accessToken: credential?.accessToken,
            responseFirebase: {
              ...responseLogin.user,
              firstName: cloneResponseLogin._tokenResponse.firstName,
              lastName: cloneResponseLogin._tokenResponse.lastName,
            },
          },
        },
      };
    }

    return response.data;
  }

  public async refreshToken(token: string) {
    const data = {
      refreshToken: token,
    };
    return this.client.post("/refresh-token", data);
  }
}
